exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".label-style {\n  font-size: 16px;\n  color: black;\n  font-weight: bold; }\n\n.margin-left-80 {\n  margin-left: 80px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/routes/print/print_routes.scss
// module id = 1009
// module chunks = 1